export default {
  getTermsVersions: (state) => state.termsVersions.all || null,
  getCurrentTermsVersion: (state) => state.termsVersions.current || null,
}